export const ACCOUNT_SEARCH = 'ACCOUNT_SEARCH';
export const DIGITAL_BILL = 'DIGITAL_BILL';
export const SIGN_IN_FORM = 'SIGN_IN_FORM';
export const SEARCH_TURNS_FORM = 'SEARCH_TURNS_FORM';
export const CREATE_TURNS_USER_INFO = 'CREATE_TURNS_USER_INFO';
